import React from "react";
import { useTranslation, Trans } from "react-i18next";

import {
  ROLE_SUBSCRIBER_ATS,
  ROLE_SUBSCRIBER_CAMPAIGN
} from "../CampaignMembers/CampaignMembers.constants";

import Selector from "../Selector";
import * as Styled from "./SubscribersSection.styled";

import { PosthogStore } from "@talentbait/shared-components";
import { withRefluxStore } from "../../Stores";

const SubscribersSection = ({
  members,
  onChangeSubscribersAts,
  onChangeSubscribersCampaign,
  onAddNewOption,
  showSubscribersAts,
  isDisabled,
  userEmail,
  // Store
  posthogInstance
}) => {
  const { t } = useTranslation();

  let showSubscriberInvite = false;
  posthogInstance?.setPersonPropertiesForFlags({ email: userEmail });
  posthogInstance?.onFeatureFlags(function () {
    showSubscriberInvite = posthogInstance?.isFeatureEnabled("campaign-subscriber-invite");
  });

  const atsSubscribersMembers = members.filter((member) => member.roleName !== "MARKETING-MANAGER");
  const campaignSubscriberMembers = members.filter(
    (member) => member.roleName !== "DEPARTMENT-SCOUT" && member.roleName !== "RECRUITER"
  );

  return (
    <Styled.SubscribersSection>
      <Styled.Description>
        <h3>{t("Notifications")}</h3>
        <p>
          {isDisabled ? (
            <Trans>
              Decide who receives notifications as soon as there is a new status for a campaign or
              when messages from applicants arrive for the recruiter. Currently, you have the{" "}
              <a href="/settings/business">collective email</a> activated, which is why individual
              email notifications are disabled.
            </Trans>
          ) : (
            <Trans>
              Decide who receives notifications as soon as there is a new status for a campaign or
              when messages from applicants arrive for the recruiter. If you want to use only one
              collective email (e.g., recruiting@talentbait.com), send us{" "}
              <a href="#" id="intercom_launcher">
                a short message.
              </a>
            </Trans>
          )}
        </p>
      </Styled.Description>

      <Styled.Container isDisabled={isDisabled}>
        <Selector
          isMulti
          members={campaignSubscriberMembers}
          onChange={onChangeSubscribersCampaign}
          onAddNewOption={() => onAddNewOption(ROLE_SUBSCRIBER_CAMPAIGN)}
          role={ROLE_SUBSCRIBER_CAMPAIGN}
          title={t("Subscribed to campaign notifications")}
          canAddNewMember={showSubscriberInvite}
        />

        {showSubscribersAts && (
          <Selector
            isMulti
            members={atsSubscribersMembers}
            onChange={onChangeSubscribersAts}
            onAddNewOption={() => onAddNewOption(ROLE_SUBSCRIBER_ATS)}
            role={ROLE_SUBSCRIBER_ATS}
            title={t("Subscribed to applicant notifications")}
            canAddNewMember={showSubscriberInvite}
          />
        )}
      </Styled.Container>
    </Styled.SubscribersSection>
  );
};

export default withRefluxStore(SubscribersSection, [PosthogStore], ["posthogInstance"]);
